import { createSlice } from '@reduxjs/toolkit';
import { TransportPackageTypeDetailStateType } from 'src/types/transportPackageType';

const initialState: TransportPackageTypeDetailStateType = {
    data: null,
    loading: false,
    deleted: false,
    error: false,
};

export const transportPackageTypeDetailSlice = createSlice({
    name: 'transportPackageTypeDetail',
    initialState,
    reducers: {
        getTransportPackageTypeDetailFetch: (state, _action) => {
            state.loading = true;
            state.error = false;
        },
        getTransportPackageTypeDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        getTransportPackageTypeDetailFetchFailure: (state) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        createTransportPackageTypeDetailFetch: (state, _action) => {
            state.loading = true;
            state.error = false;
        },
        createTransportPackageTypeDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        createTransportPackageTypeDetailFetchFailure: (state) => {
            state.loading = false;
            state.error = true;
        },
        updateTransportPackageTypeDetailFetch: (state, _action) => {
            state.loading = true;
            state.error = false;
        },
        updateTransportPackageTypeDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        updateTransportPackageTypeDetailFetchFailure: (state) => {
            state.loading = false;
            state.error = true;
        },
        deleteTransportPackageTypeDetailFetch: (state, _action) => {
            state.loading = true;
            state.error = false;
        },
        deleteTransportPackageTypeDetailFetchSuccess: (state, _action) => {
            state.deleted = true;
            state.loading = false;
        },
        deleteTransportPackageTypeDetailFetchFailure: (state) => {
            state.loading = false;
            state.error = true;
        },
        clearTransportPackageTypeDetail: () => initialState,
    },
});

export const {
    getTransportPackageTypeDetailFetch,
    getTransportPackageTypeDetailFetchSuccess,
    getTransportPackageTypeDetailFetchFailure,
    createTransportPackageTypeDetailFetch,
    createTransportPackageTypeDetailFetchSuccess,
    createTransportPackageTypeDetailFetchFailure,
    updateTransportPackageTypeDetailFetch,
    updateTransportPackageTypeDetailFetchSuccess,
    updateTransportPackageTypeDetailFetchFailure,
    deleteTransportPackageTypeDetailFetch,
    deleteTransportPackageTypeDetailFetchSuccess,
    deleteTransportPackageTypeDetailFetchFailure,
    clearTransportPackageTypeDetail,
} = transportPackageTypeDetailSlice.actions;

export default transportPackageTypeDetailSlice.reducer;
